/*********************************************************************************************
 * Splide Search
 *
 */
function initializeSplide(predictiveSearchResults) {
	const routineSections = predictiveSearchResults.querySelectorAll('[data-section-search-id]');
	let scrollCounter = 0;

	routineSections.forEach(function (section) {
		const id = '.mm-predictive-search-results-product-splide';
		const splideElem = section.querySelector(id);

		if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
			mmSplideInit(splideElem, section);
		}
	});

	function mmSplideInit(splideElem, section) {
		var splideInstance = new Splide(splideElem, {
			type: 'slide',
			arrows: true,
			pagination: false,
			gap: '16px',
			fixedWidth: '240px',
			perMove: 1,
			omitEnd: true,
			padding: {
			},
			breakpoints: {
				768: {},
			},
		}).mount();

		// Ajoute l'écouteur d'événement de défilement à splideElem
		splideElem.addEventListener('wheel', function (e) {
			// Ne pas empêcher le comportement par défaut si le défilement est vertical
			if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
				return;
			}

			// Empêche le comportement par défaut uniquement pour le défilement horizontal
			e.preventDefault();

			// Incrémente le compteur de défilements
			scrollCounter++;

			// Vérifie si le compteur atteint le seuil pour un mouvement
			if (scrollCounter >= 12) {
				// Réinitialise le compteur
				scrollCounter = 0;

				// Déplace la diapositive selon la direction du défilement horizontal
				if (e.deltaX < 0) {
					splideInstance.go('<'); // Mouvement vers la gauche
				} else if (e.deltaX > 0) {
					splideInstance.go('>'); // Mouvement vers la droite
				}
			}
		});
	}
}

/*********************************************************************************************
 * Predictive Search
 *
 */
class PredictiveSearch extends HTMLElement {
	/**
	 * Constructor to initialize the PredictiveSearch component.
	 */
	constructor() {
		super();

		this.input = this.querySelector('input[type="search"]');
		this.predictiveSearchResults = this.querySelector('#predictive-search');
		this.predictiveSearchDefault = this.querySelector('#predictive-search-default');
		this.searchContainer = null;
		this.header = null;
		this.announcementBar = null;
		this.resultsContainerOther = null;
		this.resultsContainerProduct = null;
		this.searchInput = null;

		// Tentons d'obtenir les éléments une seule fois
		this.getElements();

		// Déclencheurs d'événements
		this.input.addEventListener(
			'input',
			this.debounce((event) => {
				this.onChange(event);
				this.updateSearchContainerMaxHeight();
				this.updateOtherResultsHeight();
			}, 300).bind(this)
		);

		// Observer les changements de taille de la fenêtre
		window.addEventListener('resize', () => {
			this.updateSearchContainerMaxHeight();
			this.updateOtherResultsHeight();
		});
	}

	/**
	 * Tentons de récupérer les éléments nécessaires. 
	 * Si l'un manque, on attend un peu et on réessaie. 
	 * MAIS seulement une fois.
	 */
	getElements() {
		// On essaie de récupérer les éléments du DOM
		this.searchContainer = document.querySelector('.mm-header-search-container');
		this.header = document.querySelector('.mm-header');
		this.announcementBar = document.querySelector('.mm-announcement-bar');
		this.resultsContainerOther = document.querySelector('.mm-predictive-search-results-container-other');
		this.resultsContainerProduct = document.querySelector('.mm-predictive-search-results-container-product');
		this.searchInput = document.querySelector('.mm-header-search-container input#Search');

		// Si l'un des éléments n'est pas trouvé, réessayer après un court délai mais uniquement une fois
		if (!this.searchContainer || !this.header || !this.resultsContainerOther || !this.resultsContainerProduct || !this.searchInput) {
		} else {
			// Mettre à jour immédiatement si les éléments sont trouvés
			this.updateSearchContainerMaxHeight();
			this.updateOtherResultsHeight();
		}
	}

	/**
	 * Event handler for input changes.
	 */
	onChange() {
		const searchTerm = this.input.value.trim();

		if (!searchTerm.length) {
			this.close();
			return;
		}

		this.getSearchResults(searchTerm);
		this.getElements();
	}

	/**
	 * Fetch search results from the server based on the search term.
	 * 
	 * @param {string} searchTerm - The term to search for.
	 */
	getSearchResults(searchTerm) {
		fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
			.then((response) => {
				if (!response.ok) {
					var error = new Error(response.status);
					this.close();
					throw error;
				}

				return response.text();
			})
			.then((text) => {
				const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
				this.predictiveSearchResults.innerHTML = resultsMarkup;
				this.open();

				// Mettre à jour la hauteur des autres résultats
				this.updateOtherResultsHeight();
			})
			.catch((error) => {
				this.close();
				throw error;
			});
	}

	/**
	 * Open the predictive search results container.
	 */
	open() {
		this.predictiveSearchResults.style.display = 'block';
		this.predictiveSearchDefault.style.display = 'none';

		// Initialize Splide after the results are displayed
		initializeSplide(this.predictiveSearchResults);
		this.getElements();
	}

	/**
	 * Close the predictive search results container.
	 */
	close() {
		this.predictiveSearchResults.style.display = 'none';
		this.predictiveSearchDefault.style.display = 'flex';
	}

	/**
	 * Debounce function to limit the rate at which a function can fire.
	 * 
	 * @param {Function} fn - The function to debounce.
	 * @param {number} wait - The number of milliseconds to delay.
	 * @returns {Function} - The debounced function.
	 */
	debounce(fn, wait) {
		let t;
		return (...args) => {
			clearTimeout(t);
			t = setTimeout(() => fn.apply(this, args), wait);
		};
	}

	/**
	 * Update the height of .mm-predictive-search-results-container-other.
	 */
	updateOtherResultsHeight() {
		// Vérifier l'existence des éléments avant d'agir
		if (!this.resultsContainerOther || !this.searchContainer || !this.resultsContainerProduct || !this.searchInput) {
			return;
		}

		// Obtenir les hauteurs des éléments
		const searchContainerHeight = this.searchContainer.offsetHeight;
		const searchInputHeight = this.searchInput.offsetHeight;
		const productResultsHeight = this.resultsContainerProduct.offsetHeight;

		// Calculer la hauteur restante
		const otherResultsHeight = searchContainerHeight - searchInputHeight - 48 - productResultsHeight;

		// Appliquer la hauteur calculée, s'assurer que la hauteur n'est pas négative
		this.resultsContainerOther.style.maxHeight = `${Math.max(otherResultsHeight, 0)}px`;
	}

	/**
	 * Update the max-height of the .mm-header-search-container dynamically.
	 */
	updateSearchContainerMaxHeight() {
		if (!this.searchContainer || !this.header) return;

		// Obtenir les hauteurs des éléments
		const headerHeight = this.header.offsetHeight;
		const announcementBarHeight = this.isAnnouncementBarVisible() ? this.announcementBar.offsetHeight : 0;

		// Calculer la hauteur maximale
		const maxHeight = window.innerHeight - headerHeight - announcementBarHeight;

		// Appliquer la max-height
		this.searchContainer.style.maxHeight = `${maxHeight}px`;
	}

	/**
	 * Check if the .mm-announcement-bar is visible in the viewport.
	 * 
	 * @returns {boolean} - True if .mm-announcement-bar is in the viewport, false otherwise.
	 */
	isAnnouncementBarVisible() {
		if (!this.announcementBar) return false;

		const rect = this.announcementBar.getBoundingClientRect();
		return rect.top >= 0 && rect.bottom <= window.innerHeight;
	}
}

// Définir l'élément personnalisé une seule fois
customElements.define('predictive-search', PredictiveSearch);
